import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { schoolService } from '../services/schoolService'

export const getAllSchools = createAsyncThunk('school/getAll', async (params = {}, { rejectWithValue }) => {
  try {
    const response = await schoolService.getAll(params)
    return response
  } catch (error) {
    return rejectWithValue(error?.response?.data)
  }
})

export const getOneSchool = createAsyncThunk('student/getOne', async (data, { rejectWithValue }) => {
  try {
    const response = await schoolService.getOne(data)
    return response.data
  } catch (error) {
    return rejectWithValue(error?.response?.data)
  }
})

export const addSchool = createAsyncThunk('school/add', async (data, { rejectWithValue }) => {
  try {
    const response = await schoolService.addSchool([data])
    return response.data
  } catch (error) {
    return rejectWithValue(error?.response?.data)
  }
})


const initialState = {
  data: { data: [], current_page: 1, per_page: 10, total: 0, last_page: 1 },
  singleData: {},
  loading: false,
  error: false,
  message: '',
}

const slice = createSlice({
  name: 'schools',
  initialState,
  reducers: {
    checkAll: (state) => {
      state.isChecked = !state.isChecked
    },
    resetSingleData: (state) => {
      state.singleData = {}
    },
  },
  extraReducers: {
    [getAllSchools.pending]: (state) => {
      if (!state.data?.data?.length) {
        state.loading = true
      }
    },
    [getAllSchools.fulfilled]: (state, action) => {
      state.error = false
      state.data = action.payload
      state.loading = false
    },
    [getAllSchools.rejected]: (state, action) => {
      state.error = true
      state.message = action.payload
      state.loading = false
    },

    [getOneSchool.pending]: (state) => {
      state.loading = true
    },
    [getOneSchool.fulfilled]: (state, { payload }) => {
      state.message = payload?.message
      state.loading = false
      state.singleData = payload
    },
    [getOneSchool.rejected]: (state, { payload }) => {
      state.error = true
      state.message = payload
      state.loading = false
    },

    [addSchool.pending]: (state) => {
      state.loading = true
    },
    [addSchool.fulfilled]: (state, { payload }) => {
      state.message = payload?.message
      state.loading = false
      state.singleData = payload
    },
    [addSchool.rejected]: (state, { payload }) => {
      state.error = true
      state.message = payload
      state.loading = false
    },

  },
})



export const { resetSingleData } = slice.actions
export default slice.reducer
